import React, { useState } from 'react'
import { Settings, User, RefreshCw } from 'lucide-react'
import { MOCK_USERS, isDevelopmentMode } from '../utils/mockData'
import useAppStore from '../store/useAppStore'

const DevTools = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { telegramUser, setTelegramUser, setLanguage } = useAppStore()

  // Only show in development mode
  if (!isDevelopmentMode()) {
    return null
  }

  const switchUser = (userKey) => {
    const user = MOCK_USERS[userKey]
    setTelegramUser(user)
    setLanguage(user.language_code || 'ru')
    console.log('🔧 Switched to user:', user)
  }

  const refreshApp = () => {
    window.location.reload()
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-yellow-500 text-black p-3 rounded-full shadow-lg hover:bg-yellow-400 transition-colors"
        title="Dev Tools"
      >
        <Settings size={20} />
      </button>

      {/* Dev Panel */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 bg-gray-900 border border-gray-700 rounded-lg p-4 min-w-[300px] shadow-xl">
          <div className="flex items-center gap-2 mb-4 text-yellow-400">
            <Settings size={16} />
            <span className="font-semibold">Dev Tools</span>
          </div>

          {/* Current User Info */}
          <div className="mb-4 p-3 bg-gray-800 rounded">
            <div className="text-sm text-gray-400 mb-1">Current User:</div>
            <div className="text-white">
              <div className="flex items-center gap-2">
                <User size={14} />
                <span>{telegramUser?.first_name} {telegramUser?.last_name}</span>
              </div>
              <div className="text-xs text-gray-400 mt-1">
                ID: {telegramUser?.id} | Lang: {telegramUser?.language_code}
              </div>
            </div>
          </div>

          {/* User Switcher */}
          <div className="mb-4">
            <div className="text-sm text-gray-400 mb-2">Switch User:</div>
            <div className="space-y-2">
              {Object.entries(MOCK_USERS).map(([key, user]) => (
                <button
                  key={key}
                  onClick={() => switchUser(key)}
                  className={`w-full text-left p-2 rounded text-sm transition-colors ${
                    telegramUser?.id === user.id
                      ? 'bg-yellow-600 text-black'
                      : 'bg-gray-700 text-white hover:bg-gray-600'
                  }`}
                >
                  <div className="font-medium">
                    {user.first_name} {user.last_name}
                  </div>
                  <div className="text-xs opacity-70">
                    ID: {user.id} | {user.language_code?.toUpperCase()}
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-2">
            <button
              onClick={refreshApp}
              className="w-full flex items-center gap-2 p-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
            >
              <RefreshCw size={14} />
              Refresh App
            </button>
          </div>

          {/* Info */}
          <div className="mt-4 p-2 bg-gray-800 rounded text-xs text-gray-400">
            <div>🔧 Development Mode</div>
            <div>Mock data is being used</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default DevTools
